export const styles = {
  table: {
    minWidth: 350,
  },
  cell: {
    width: '70%',
  },
};
